<template>
    <v-row justify="center" class="border-radius-3">
        <v-dialog v-model="dialog" persistent width="700" class="border-radius-3" hide-overlay>
            <v-card class="border-radius-3 pa-5">
                <v-card-title class=" d-flex justify-center"
                    ><span
                        class="titles text-h6 font-weight-medium primary--text py-3 d-flex justify-center"
                        >{{ $t('initialTour.avatar_select') }}</span
                    ></v-card-title
                >
                <v-container fluid class="">
                    <div class="cont">
                        <v-btn
                            icon
                            class="but pa-0 d-none d-md-block secondary"
                            data-cy="rigth-click-button"
                            @click="shiftRight()"
                        >
                            <v-icon class="white--text icon-rotate">
                                mdi-trending-neutral
                            </v-icon>
                        </v-btn>
                        <div class="cards-wrapper">
                            <ul
                                class="cards__container pa-0"
                                id="cards-swiped"
                                v-on:swiped-left="shiftLeft"
                                v-on:swiped-right="shiftRight"
                            >
                                <li
                                    class="box"
                                    v-for="(avatar, index) of defaultAvatarPack.avatarDTOList"
                                    :key="index"
                                >
                                    <Avatar :avatar="avatar"></Avatar>
                                </li>
                            </ul>
                        </div>
                        <v-btn
                            icon
                            secondary
                            class="but d-none d-md-block secondary"
                            data-cy="left-click-button"
                            @click="shiftLeft()"
                        >
                            <v-icon class="white--text">
                                mdi-trending-neutral
                            </v-icon>
                        </v-btn>
                    </div>
                </v-container>
                <v-card-actions class="d-flex justify-center">
                    <v-btn data-cy="continue-button-avatar-select" color="secondary px-15" large rounded @click="nextPass">{{
                        $t('initialTour.continue')
                    }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>
<script>
/* eslint-disable no-plusplus */

import { mapState, mapActions } from 'vuex'
import Avatar from './AvatarCore/Avatar.vue'

export default {
    components: {
        Avatar,
    },
    props: {
        dialog: { type: Boolean, default: false },
    },
    computed: {
        ...mapState({
            user: (state) => state.userData.user,
            defaultAvatarPack: (state) => state.dashboard.defaultAvatarPack,
        }),
    },
    mounted() {
        setTimeout(() => {
            this.initBoxes()
        }, 0)
    },
    methods: {
        ...mapActions('dashboard', ['showCategories', 'showAvatars']),
        ...mapActions('userData', ['changeAvatar']),
        initBoxes() {
            const boxes = document.querySelectorAll('.box')
            if (boxes.length > 5) {
                for (let i = 5; i < boxes.length; i++) {
                    boxes[i].classList.add('box--hide')
                }
            }

            boxes[2].childNodes[0].childNodes[0].classList.add('avatar-active')
        },
        shiftLeft() {
            const boxes = document.querySelectorAll('.box')
            const tmpNode = boxes[0]
            boxes[0].className = 'box move-out-from-left'

            setTimeout(() => {
                document.querySelector('.avatar-active').classList.toggle('avatar-active')
                if (boxes.length > 5) {
                    tmpNode.classList.add('box--hide')
                    boxes[5].className = 'box move-to-position5-from-left'
                }
                boxes[1].className = 'box move-to-position1-from-left'
                boxes[2].className = 'box move-to-position2-from-left'
                boxes[3].className = 'box move-to-position3-from-left'

                boxes[3].childNodes[0].childNodes[0].className += ' avatar-active'
                document
                    .querySelector('.avatar-active')
                    .querySelector('img')
                    .setAttribute(
                        'src',
                        document.querySelector('.avatar-active').querySelector('img').src
                    )

                boxes[4].className = 'box move-to-position4-from-left'
                boxes[0].remove()

                document.querySelector('.cards__container').appendChild(tmpNode)
            }, 200)
        },
        shiftRight() {
            document.querySelector('.avatar-active').classList.toggle('avatar-active')
            const boxes = document.querySelectorAll('.box')
            boxes[4].className = 'box move-out-from-right'
            setTimeout(() => {
                const noOfCards = boxes.length
                if (noOfCards > 4) {
                    boxes[4].className = 'box box--hide'
                }

                const tmpNode = boxes[noOfCards - 1]
                tmpNode.classList.remove('box--hide')
                boxes[noOfCards - 1].remove()
                const parentObj = document.querySelector('.cards__container')
                parentObj.insertBefore(tmpNode, parentObj.firstChild)
                tmpNode.className = 'box move-to-position1-from-right'
                boxes[0].className = 'box move-to-position2-from-right'
                boxes[1].className = 'box move-to-position3-from-right'

                boxes[1].childNodes[0].childNodes[0].className += ' avatar-active'
                document
                    .querySelector('.avatar-active')
                    .querySelector('img')
                    .setAttribute(
                        'src',
                        document.querySelector('.avatar-active').querySelector('img').src
                    )

                boxes[2].className = 'box move-to-position4-from-right'
                boxes[3].className = 'box move-to-position5-from-right'
            }, 200)
        },
        nextPass() {
            const avatarSelect = document.querySelector('.avatar-active').getAttribute('id')
            const found = this.defaultAvatarPack.avatarDTOList.find(
                (el) => Number(el.id) === Number(avatarSelect)
            )
            if (!found) {
                this.$modal.show({ text: 'Debes seleccionar un avatar para continuar' })
                // alert('Debes seleccionar un avatar para continuar')
                return
            }
            this.changeAvatar(found)
            this.showAvatars()
            this.showCategories()
        },
    },
}
</script>
<style>
.icon-rotate {
    transform: rotate(180deg);
}

.cont {
    display: flex;
    justify-content: center;
    align-items: center;
}

.but {
    /* margin-left: 0 3%; */
    width: 2rem;
    cursor: pointer;
    z-index: 30;
}

.but--inactive {
    opacity: 0.2;
}

.but img {
    width: 60%;
}

.cards-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 76%;
    background-color: transparent;
}

.cards__container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 10rem;
    width: 80vh;
    margin: 0;
}

.box {
    box-shadow: 0px 0px 2vh 0px #888888;
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 3;
    border-radius: 500px;
}

.box:nth-child(2n) {
    transform: scale(0.85);
    z-index: 2;
}

.box:nth-child(2) {
    left: 5%;
}

.box:nth-child(4) {
    left: -5%;
}

.box:nth-child(4n + 1) {
    transform: scale(0.75);
    z-index: 1;
}

.box:nth-child(1) {
    left: 15%;
}

.box:nth-child(5) {
    left: -15%;
}

.card__title {
    padding: 1rem;
}

.box--hide {
    display: none !important;
}
</style>
